<template>
  <v-main>
    <v-container dir="rtl">     
      <v-row dir="rtl">
        <v-col v-for="(vesselHatch, index) in vesselMonitoringData?.vesselHatches"  :key="`all-monitoring-bay-${index}`" >
          <vessel-monitoring-hatch   :vesselHatchIndex="index" :vesselHatch='vesselHatch' :minDeckTiersNo="vesselMonitoringData?.minDeckTiersNo"
          :minHoldTiersNo="vesselMonitoringData?.minHoldTiersNo"></vessel-monitoring-hatch>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import VesselMonitoringHatch from '../VesselMonitoringBay/VesselMonitoringHatch.vue';
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    VesselMonitoringHatch,
  },
  provide() {
    return {
      readonly: this.readonly
    }
  },
  data() {
    return {
    };
  },
  props: {
    readonly: {
      default: false,
      type: Boolean,
    },    
  },
  computed: {
    ...mapGetters(["getStowagInstructionData"]),
    
    vesselMonitoringData() {
      return this.getStowagInstructionData;
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.container-type-legend {
display: flex;
gap: 1rem;
justify-content: center;
align-items: center;
}

.container-type-legend v-badge {
margin-right: 10px;
}

.container-icons {
display: flex;
justify-content: center;
align-items: center;
gap: 2rem;
flex-wrap: wrap;
}

.container-icons v-icon {

font-size: 18px;
margin-right: 10px;
}

.container-type-legend v-badge[color="red"]::before {
background-color: red;
}

.container-type-legend v-badge[color="grey"]::before {
background-color: grey;
}

.container-type-legend v-badge[color="blue"]::before {
background-color: blue;
}
</style>

